import moduleShared from './shared';
import moduleMap from './map';
import moduleUserTemplate from './user-template';
import moduleAccessProjects from './access-projects';
import modulePublisher from './publisher';
import moduleVerify from './verify';
import moduleAppPermissions from './app-permissions';
import moduleFolderStructure from './folder-structure';
import moduleProjectTypes from './project-types';
import moduleActivityLog from './activity-log';
import moduleHelp from './help';
import moduleProjectCreatorModelTemplate from './project-creator-model-template';
import moduleAppEmailsNotification from './app-emails-notification';
import moduleAppViewerEnscapePanorama from './app-viewer-enscape-panorama';
import moduleRequestUpgrade from './request-upgrade';

export default {
  namespaced: true,
  modules: {
    shared: moduleShared,
    map: moduleMap,
    userTemplate: moduleUserTemplate,
    accessProjects: moduleAccessProjects,
    publisher: modulePublisher,
    verify: moduleVerify,
    appPermissions: moduleAppPermissions,
    folderStructure: moduleFolderStructure,
    projectTypes: moduleProjectTypes,
    activityLog: moduleActivityLog,
    projectCreatorModelTemplate: moduleProjectCreatorModelTemplate,
    appEmailsNotification: moduleAppEmailsNotification,
    help: moduleHelp,
    appViewerEnscapePanorama: moduleAppViewerEnscapePanorama,
    upgradeRequests: moduleRequestUpgrade,
  },
};
